<template>
  <li
    :class="[
      { 'timeline-inverted': inverted },
      { 'timeline-simple': !inverted }
    ]"
  >
    <slot name="badge">
      <div class="timeline-badge" :class="badgeType">
        <md-icon>{{ badgeIcon }}</md-icon>
      </div>
    </slot>
    <div class="timeline-panel">
      <div class="timeline-body">
        <h3>
          {{ formatStartDate(data.startDate) }} -
          {{ formatStopDate(data.stopDate) }}
          <md-button
            class="md-success md-sm"
            @click.native="handleEdit(data.id, data.shift_id)"
          >
            Bewerken
          </md-button>
          <md-button
            class="md-danger md-sm"
            @click.native="
              handleDelete(
                data.id,
                data.shift_id,
                data.startDate,
                data.stopDate
              )
            "
          >
            Verwijderen
          </md-button>
        </h3>
        <md-list class="md-dense">
          <md-subheader>Geselecteerde routes:</md-subheader>
          <md-list-item
            v-for="(item, index) in displayTimePeriodRoutes()"
            :key="index"
          >
            {{ item.shiftName }}
          </md-list-item>
        </md-list>
      </div>
      <div class="md-layout">
        <div
          class="md-layout-item md-xsmall-size-40"
          v-for="(dayOfTheWeek, dayOfTheWeekIndex) in {
            monday: 'Maandag',
            tuesday: 'Dinsdag',
            wednesday: 'Woensdag',
            thursday: 'Donderdag',
            friday: 'Vrijdag',
            saturday: 'Zaterdag',
            sunday: 'Zondag'
          }"
          :value="dayOfTheWeek"
          :key="dayOfTheWeekIndex"
        >
          <md-card>
            <md-card-content>
              <div class="text-center">
                {{ dayOfTheWeek }} {{ displayTimePeriod(dayOfTheWeekIndex) }}
                <br />
                <md-icon
                  class="material-icons"
                  :class="[
                    { 'color-green': colorGreen(data[dayOfTheWeekIndex]) },
                    { 'color-red': !colorGreen(data[dayOfTheWeekIndex]) }
                  ]"
                >
                  <template v-if="colorGreen(data[dayOfTheWeekIndex])">
                    check_circle
                  </template>
                  <template v-else>
                    cancel
                  </template>
                </md-icon>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <div class="md-layout" v-if="hasSubPeriods">
        <div class="md-layout-item md-xsmall-size">
          <time-line plain type="simple">
            <time-line-item-shift-period
              inverted
              badge-type="primary"
              badge-icon="schedule"
              v-for="(period, index) in this.dataPeriods"
              :key="index"
              v-model="data.periods[index]"
              :data="period"
              :routes="routes"
            ></time-line-item-shift-period>
          </time-line>
        </div>
      </div>
      <h6 v-if="$slots.footer">
        <slot name="footer"></slot>
      </h6>
    </div>
  </li>
</template>
<script>
import { TimeLine, TimeLineItemShiftPeriod } from "@/components";
import swal from "sweetalert2";
export default {
  name: "time-line-item-shift-period",
  components: {
    TimeLine,
    TimeLineItemShiftPeriod
  },
  props: {
    inverted: Boolean,
    data: {
      type: Object,
      default: function() {
        return {
          id: "",
          shift_id: "",
          startDate: null,
          stopDate: null,
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0,
          sunday: 0,
          mondayStartTime: null,
          mondayStopTime: null,
          tuesdayStartTime: null,
          tuesdayStopTime: null,
          wednesdayStartTime: null,
          wednesdayStopTime: null,
          thursdayStartTime: null,
          thursdayStopTime: null,
          fridayStartTime: null,
          fridayStopTime: null,
          saturdayStartTime: null,
          saturdayStopTime: null,
          sundayStartTime: null,
          sundayStopTime: null,
          periods: [],
          route_ids: []
        };
      }
    },
    badgeType: {
      type: String,
      default: "success"
    },
    badgeIcon: {
      type: String,
      default: ""
    },
    routes: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    formatStartDate(date) {
      date = this.formatDate(date);

      if (typeof date === "string") {
        return date;
      }

      return "Begin";
    },
    formatStopDate(date) {
      date = this.formatDate(date);

      if (typeof date === "string") {
        return date;
      }

      return "Einde";
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    colorGreen: function(type) {
      if (type === 1) {
        return true;
      }

      return false;
    },
    displayTimePeriodRoutes: function() {
      var routes = [];

      for (var i in this.routes) {
        if (!this.data.route_ids.includes(this.routes[i]["id"])) {
          continue;
        }
        routes.push(this.routes[i]);
      }

      return routes;
    },
    displayTimePeriod: function(day) {
      if (!this.data[day]) {
        return "";
      }

      var keyStartTime = day + "StartTime";
      var keyStopTime = day + "StopTime";

      return (
        (this.data[keyStartTime] !== null
          ? this.data[keyStartTime].substring(0, 5)
          : "") +
        " - " +
        (this.data[keyStopTime] !== null
          ? this.data[keyStopTime].substring(0, 5)
          : "")
      );
    },
    handleEdit(id, routeId) {
      this.$router.push("/shifts/periods/" + routeId + "/edit/" + id);
    },
    handleDelete(id, routeId, startDate, stopDate) {
      swal
        .fire({
          title: "Weet u het zeker?",
          text: `Route periode "${startDate}-${stopDate}" wordt uit het systeem verwijderd.`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Verwijderen",
          cancelButtonText: "Annuleren",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$http.delete(this.$apiBaseUrl + "shifts/period/" + id).then(
              response => {
                this.notifyVue(
                  "Route periode succesvol verwijderd",
                  "check",
                  "success",
                  5000
                );

                this.data.id = "";
              },
              response => {
                if (response.status == "403") {
                  this.notifyVue(
                    "U heeft geen rechten voor het beheren van route perioden",
                    "add_alert",
                    "danger",
                    0
                  );
                }
              }
            );
          }
        });
    },
    deleteRow(id) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  computed: {
    hasSubPeriods: function() {
      return this.dataPeriods.length > 0;
    },
    dataPeriods: function() {
      var periods = [];

      for (var i in this.data.periods) {
        if (this.data.periods[i].id.length !== 36) {
          continue;
        }

        periods.push(this.data.periods[i]);
      }

      return periods;
    }
  }
};
</script>
<style>
.color-red {
  color: red !important;
}
.color-green {
  color: green !important;
}
.md-list.md-dense .md-list-item-content {
  min-height: 20px;
}
.md-list-item .md-list-item-container .md-ripple {
  padding: 0 15px;
}
</style>
